import { TextDisplayCell } from "../../../common/components/DataGrid";
import { TextSelectEditor } from "../../../common/components/DataGrid/DataGridHelper";
import {
  generateHwioBoardNumberCell,
  generateHwioChannelNumberCell,
  generateHwioIOTypeCell,
} from "../../helpers/CellGenerators";
import {
  getHwioChannelOptions,
  getHwioChannelPrefix,
} from "../../helpers/Helpers";

export const HwioIOTypeCell = ({ row, lookupValues }) => {
  return <TextDisplayCell value={generateHwioIOTypeCell(row, lookupValues)} />;
};

export const HwioChannelNumberCell = ({ row, lookupValues }) => {
  return (
    <TextDisplayCell value={generateHwioChannelNumberCell(row, lookupValues)} />
  );
};

export const HwioBoardNumberCell = ({ row, lookupValues }) => {
  return (
    <TextDisplayCell value={generateHwioBoardNumberCell(row, lookupValues)} />
  );
};

/**
 * Channel Number editor. The option labels depend on the row's own I/O type, so the list is built
 * per row rather than supplied through the column's `editorProps`.
 */
export const HwioChannelNumberEditorCell = ({
  value,
  row,
  lookupValues,
  onCommit,
  onCancel,
}) => {
  const options = getHwioChannelOptions(
    getHwioChannelPrefix(row, lookupValues)
  );

  return (
    <TextSelectEditor
      value={value}
      options={options}
      onCommit={onCommit}
      onCancel={onCancel}
      placeholder='Channel'
    />
  );
};
